export enum SurveyProperties {
    IntervalDays = Number.parseInt(
        process.env.REACT_APP_SATISFACTION_SURVEY_DAYS_TO_SHOW_MODAL ?? "30",
        10
    ),
    TransactionTimeout = Number.parseInt(
        process.env.REACT_APP_SATISFACTION_SURVEY_TRANSACTION_TIMEOUT ?? "5000",
        10
    ),
}
